import { formTypesService } from "../../services";
import { uiConstants, formTypesConstants as constants } from "../constants";

const getTypes = () => {
  return (dispatch) => {
    dispatch({
      type: uiConstants.LOADING_UI,
    });
    formTypesService
      .types()
      .then((response) => {
        dispatch({
          type: constants.RETRIEVE_FORM_TYPES,
          payload: response.data.data,
        });
        dispatch({ type: uiConstants.CLEAR_ERRORS });
      })
      .catch((response) => {
        console.error(response);
        if (response.data !== undefined) {
          dispatch({
            type: uiConstants.SET_ERRORS,
            payload: response.data.message,
          });
        }
      });
  };
};

export const formTypesActions = { getTypes };
